/**
 * Fixed corner call-to-action that fades in after the page scrolls past a
 * threshold. While hidden it is `inert` and `hidden`, so it never receives
 * focus or appears in the accessibility tree.
 */
class StickyCta extends HTMLElement {
  #revealOffset = 280;
  #ticking = false;

  connectedCallback() {
    const offset = Number(this.dataset.revealOffset);
    if (!Number.isNaN(offset) && offset > 0) this.#revealOffset = offset;

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }

  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#update();
      this.#ticking = false;
    });
  };

  #update() {
    const visible = window.scrollY > this.#revealOffset;
    if (visible) {
      this.hidden = false;
      this.inert = false;
      // Double rAF so the unhide paints before the opacity transition starts.
      requestAnimationFrame(() => this.setAttribute('data-visible', 'true'));
    } else {
      this.removeAttribute('data-visible');
      this.hidden = true;
      this.inert = true;
    }
  }
}

if (!customElements.get('sticky-cta')) {
  customElements.define('sticky-cta', StickyCta);
}
